import { render, staticRenderFns } from "./ProductTab.vue?vue&type=template&id=f3e2592a"
import script from "./ProductTab.vue?vue&type=script&lang=js"
export * from "./ProductTab.vue?vue&type=script&lang=js"
import style0 from "./ProductTab.vue?vue&type=style&index=0&id=f3e2592a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports